import React from "react"
import Link from "gatsby-link"
import AboutComponent from "../components/About"
import coolbg from "../images/guidelines.jpeg"
import Layout from "../components/layout"

const GuidelinesPage = () => (
  <Layout>
    <div>
      <meta name="apple-itunes-app" content="app-id=1322754821" />
      <meta name="title" content="Community Guidelines - The Views News" />
      <meta
        name="description"
        content="Views Community seeks to foster original writing that informs, educates, and expresses truths boldly."
      />

      <meta property="og:type" content="website" />
      <meta
        property="og:url"
        content="https://viewsnews.co/community-guidelines"
      />
      <meta
        property="og:title"
        content="Community Guidelines - The Views News"
      />
      <meta
        property="og:description"
        content="Views Community seeks to foster original writing that informs, educates, and expresses truths boldly."
      />
      <meta
        property="og:image"
        content="https://i.postimg.cc/6qs9mJ4r/Top-Shelf-Copy.jpg"
      />

      <meta property="twitter:card" content="summary_large_image" />
      <meta
        property="twitter:url"
        content="https://viewsnews.co/community-guidelines"
      />
      <meta
        property="twitter:title"
        content="Community Guidelines - The Views News"
      />
      <meta
        property="twitter:description"
        content="Views Community seeks to foster original writing that informs, educates, and expresses truths boldly."
      />
      <meta
        property="twitter:image"
        content="https://i.postimg.cc/6qs9mJ4r/Top-Shelf-Copy.jpg"
      />
      <AboutComponent
        image={coolbg}
        title="Community Guidelines"
        text="Views Community seeks to foster original writing that informs, educates, and expresses truths boldly."
      />
      <div className="PrivacyBody">
        <h3>Last updated February 18, 2019</h3>
        <p>
          The Views Community is an open platform for authentic voices to share
          their thoughts and experiences, and through conversation move us
          towards greater understanding. Views Community seeks to foster
          original writing that informs, educates, and expresses truths boldly.
          To be eligible for inclusion from member-only content, user posts must
          meet Views' Rules as well as the following guidelines and content
          requirements.
        </p>
        <p>
          <b>
            Please read these guidelines carefully as it will help you make
            informed decisions when posting your stories to the Community.
          </b>
        </p>

        <h2>1. Editorial Guidelines</h2>
        <p>
          All types of thinkers, writers, and journalists can share their
          personal opinions about the news. If you have an idea to share
          respectfully, it’s welcome to be published to the Community. We
          encourage you to highlight your own perspective, rather than
          summarizing the news article — whether that comes from real-world
          experience, original research, or reporting in the field. Here's how
          you can get the best out of the Community:
        </p>
        <h3>1.1 Profile</h3>
        <p>
          Try to complete your profile. Entering a real name and adding a
          profile picture can help readers relate to your message on a personal
          basis.
        </p>
        <h3>1.2 News Articles</h3>
        <p>
          Each personal story needs to be backed by a news article. In order to
          promote trust and accountability within the platform, we ask that you
          link your story to news articles which come from verifiable, honest
          publications. Most articles are covered. If you feel that a news
          publication has not been included in out list of "true news", feel
          free to share your concerns.
        </p>
        <h3>1.3 Finishing Touches</h3>
        <p>
          We strongly recommend scanning for typos before publishing and
          sharing. We also ask that you link your story to news articles that
          have been published in the past day or two so Community stories always
          keep readers updated with the latest happenings.
        </p>
        <h3>1.4 Let the Conversation Live</h3>
        <p>
          Keep active in the channels and try to respond to new opinions. Like
          the comments you get and engage with readers, where appropriate.
        </p>

        <h2>2. Content Guidelines</h2>
        <h3>2.1 Advertising</h3>
        <p>You may not sell advertising in or on your content</p>
        <h3>2.2 Sponsorships</h3>
        <p>
          If you have been sponsered by a news publication to drive views to
          their website, you must state this in your story.
        </p>
        <h3>2.3 Posts</h3>
        <h4>2.3.1 Title</h4>
        <ul>
          <li>Use an appropriate title for your story.</li>
          <li>
            Clickbait titles will be reported and considered as an{" "}
            <a href="#Third">infraction</a>.
          </li>
          <li>Each title is allowed a maximum of 15 words.</li>
        </ul>
        <h4>2.3.2 Story</h4>
        <ul>
          <li>
            Make sure your story is, in some way, related to the news article.
          </li>
          <li>
            To ensure you are contributing something meaningful, we ask that you
            have a minimum of 50 words stretching to an unlimited number of
            words.
          </li>
          <li>No foul language or derogatory terms are allowed.</li>
          <li>
            As of right now, we ask that all posts be written in English. In the
            future, we will work towards localization of different languages.
          </li>
        </ul>
        <h4>2.3.3 Tags</h4>
        <ul>
          <li>Add reatable tags to your story that can help with discovery.</li>
          <li>
            Try to keep tags short, something that relates to your story and is
            likely to be searched for. This promotes views to your post and
            exposure to the right audience.
          </li>
        </ul>
        <h4>2.3.4 Category</h4>
        <ul>
          <li>Link your post to one of the six categories.</li>
          <li>
            This ensures other users can have a more personalized experience.
          </li>
        </ul>

        <h2 id="Third">3. Infractions</h2>
        <h3>3.1 Minor Infractions</h3>
        <p>
          Minor infractions are easy to fix. Usually these are small problems
          like typos or unrelated tags. These issues can be fixed with a simple
          edit. Ignoring requests to correct a minor infraction can lead into a
          major infraction.
        </p>
        <h3>3.2 Major Infractions</h3>
        <h4>3.2.1 First Major Infraction</h4>
        <p>
          For a first-time infraction, you will still be allowed to post to the
          Community as a free member. However, you have used up one of three
          chances to redeem yourself.
        </p>
        <h4>3.2.2 Second Major Infraction</h4>
        <p>
          If you violate a major guideline for the second time, you will be
          banned from the Views Community for exactly one month. In this month,
          your Premium membership will also be revoked.
        </p>
        <h4>3.2.3 Third Major Infraction</h4>
        <p>
          If you violate the guidelines a third time, you will suspended from
          the Community and you account will be disabled.
        </p>
      </div>
    </div>
  </Layout>
)

export default GuidelinesPage
